//functions
import * as Functions from '../functions/common';

// models
import { PractitionerConsumptionSyncProcess } from '../models/Entities/Practitioners/PractitionerConsumptionSyncProcess';
import { IResult } from '../models/HttpResult';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/practitioners/';

// get all sync process by practitioner id
export const GetPractitionerConsumptionSyncProcesses = async (
    practitionerId: string,
    token: string
): Promise<PractitionerConsumptionSyncProcess[]> => {
    let RequestURL: string = BaseURL + practitionerId + '/consumptions/sync';
    try {
        const Response: PractitionerConsumptionSyncProcess[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess[]>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// get practitioner consumption sync process by id

export const GetPractitionerConsumptionSyncProcessById = async (
    token: string,
    processId: string
): Promise<PractitionerConsumptionSyncProcess> => {
    let RequestURL: string = BaseURL + '/consumptions/sync/' + processId;
    try {
        const Response: PractitionerConsumptionSyncProcess = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// get last practitioner consumption sync process

export const GetLastPractitionerConsumptionSyncProcess = async (
    practitionerId: string,
    token: string
): Promise<PractitionerConsumptionSyncProcess> => {
    let RequestURL: string = BaseURL + practitionerId + '/consumptions/sync/last';
    try {
        const Response: PractitionerConsumptionSyncProcess = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'GET'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Add practitioner consumption sync process

export const AddPractitionerConsumptionSyncProcess = async (
    practitionerId: string,
    token: string
): Promise<PractitionerConsumptionSyncProcess> => {
    let RequestURL: string = BaseURL + 'consumptions/sync';
    try {
        const Response: PractitionerConsumptionSyncProcess = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'POST',
        body: JSON.stringify({practitionerId: practitionerId})  
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// update practitioner consumption sync process

export const UpdatePractitionerConsumptionSyncProcess = async (
    token: string,
    SyncProcess: PractitionerConsumptionSyncProcess
): Promise<PractitionerConsumptionSyncProcess> => {
    let RequestURL: string = BaseURL + '/consumptions/sync/';
    try {
        const Response: PractitionerConsumptionSyncProcess = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(SyncProcess),
        method: 'PUT'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// delete practitioner consumption sync process

export const DeletePractitionerConsumptionSyncProcess = async (
    token: string,
    id: string
): Promise<PractitionerConsumptionSyncProcess> => {
    let RequestURL: string = BaseURL + '/consumptions/sync/' + id;
    try {
        const Response: PractitionerConsumptionSyncProcess = await fetch(RequestURL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        method: 'DELETE'
        })
        .then((response) => {
            if (!response.ok) {
            throw response;
            } else {
            return response.json() as Promise<IResult<PractitionerConsumptionSyncProcess>>;
            }
        })
        .then((data: IResult<PractitionerConsumptionSyncProcess>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
            throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};